var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mapcomponent" } }, [
    !_vm.cookiesAllowed
      ? _c("div", { staticClass: "no-cookies" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _vm.currentLang === "it"
              ? _c("span", [
                  _vm._v(
                    "\n\t\t  Mappa stradale fornita da OpenStreetMap bloccata in assenza di tua autorizzazione.\n\t\t  Per vederla, modifica le tue impostazioni sui cookie\n\t\t  e dai il consenso a OpenStreetMap.\n\t\t"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentLang === "en"
              ? _c("span", [
                  _vm._v(
                    "\n\t\t  The map provided by OpenStreetMap was blocked, because your authorization is missing.\n\t\t  To see it, please update your cookie preferences\n\t\t  and allow OpenStreetMap,\n\t\t"
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.cookiesAllowed
      ? _c("div", [
          _c("div", {
            staticStyle: { height: "240px", "margin-bottom": "2rem" },
            attrs: { id: "leaflet-container" },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fa-stack fa-1x" }, [
      _c("i", {
        staticClass: "far fa-slash fa-stack-1x",
        staticStyle: { color: "red" },
      }),
      _vm._v(" "),
      _c("i", { staticClass: "far fa-cookie-bite fa-stack-1x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }